import { Button, Tooltip, Card } from "tunggal";
import React from 'react';
export default {
  Button,
  Tooltip,
  Card,
  React
};